import 'jquery-address';
import '@situation/setdesign.common';
import '@situation/setdesign.directives.accessibility';
import '@situation/setdesign.tag-manager';
import { importAll } from '@situation/setdesign.util';

importAll(require.context('../images', true));
importAll(require.context('./components', false));
